<template>
  <div class="h-100">
    <Layout ref="layout">
      <template v-slot:body>
        <Crud
          :modal="true"
          @delete="$refs.datatable.update()"
          @create="$refs.datatable.update()"
          @onformcreate="onformcreate"
          @forceRerender="$refs.datatable.update()"
          name="Api token"
          names="Api tokens"
          button="+"
          @filter="$refs.datatable.applyFilters($event)"
          url="/ApiToken"
          :iniorderby="{ column: 'created', type: 'DESC' }"
        >
          <template v-slot:list="form">
            <Datatable
              ref="datatable"
              :fields="fields"
              :fieldsMobile="fieldsMobile"
              :url="'/ApiToken/Read'"
              @edit="form.crud.edit($event)"
              @delete="form.crud.delete($event)"
              :where="where"
              :mobileCardMode="true"
            >
              <template v-slot:privateToken="data">
                <div>
                  <div v-if="isMobile()" class="mb-1">
                    <strong>Chave privada:</strong>
                  </div>
                  <div style="display: flex; align-items: center; justify-content: space-between; gap: 8px">
                    <span class="copy-token" style="overflow: hidden; text-overflow: ellipsis">{{ data.row.privateToken }}</span>
                    <i
                      class="tf-icons bx bx-copy text-primary"
                      style="cursor: pointer; flex-shrink: 0; line-height: 1"
                      @click="copyTextToClipboard(data.row.privateToken, $event)"
                    ></i>
                  </div>
                </div>
              </template>
              <template v-slot:publicToken="data">
                <div>
                  <div v-if="isMobile()" class="mb-1">
                    <strong>Chave pública:</strong>
                  </div>
                  <div style="display: flex; align-items: center; justify-content: space-between; gap: 8px">
                    <span class="copy-token" style="overflow: hidden; text-overflow: ellipsis">{{ data.row.publicToken }}</span>
                    <i
                      class="tf-icons bx bx-copy text-primary"
                      style="cursor: pointer; flex-shrink: 0; line-height: 1"
                      @click="copyTextToClipboard(data.row.publicToken, $event)"
                    ></i>
                  </div>
                </div>
              </template>
            </Datatable>
          </template>
          <template v-slot:form="form">
            <div class="row">
              <div class="mb-3 col-md-12 col-12">
                <label class="form-label">Nome *</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="form.crud.form.nome"
                />
                <Error
                  v-if="form.crud.error"
                  :error="form.crud.error.nome"
                ></Error>
              </div>
              <div class="mb-3 col-md-6 col-12">
                <label class="form-label">Expiração </label>
                <i
                    class="tf-icons bx bx-infinite text-primary"
                    style="cursor: pointer; margin-left: 3px;"
                    @click="noExpire(form)"
                    title="Nunca Expira"
                  ></i>
                <input
                  v-if="!ilimitado"
                  id="date"
                  type="datetime-local"
                  class="form-control"
                  v-model= "form.crud.form.expire"
                />
                <Error
                  v-if="form.crud.error"
                  :error="form.crud.error.expire"
                ></Error>
              </div>
              <div class="mb-3 col-md-6 col-12">
                <label class="form-label">Usuário *</label>
                <div class="user-search-select" ref="userSelectWrap">
                  <input
                    type="text"
                    class="form-control"
                    :placeholder="loadingUsers ? 'Carregando...' : 'Pesquisar usuário'"
                    :value="userSearchOpen ? userSearch : userInputDisplay(form.crud.form.usuarioId)"
                    @focus="openUserSearch(form.crud.form.usuarioId)"
                    @input="userSearch = $event.target.value; userSearchOpen = true; updateUserDropdownPos()"
                    @keydown.esc="userSearchOpen = false"
                  />
                  <i
                    v-if="form.crud.form.usuarioId != null && !userSearchOpen"
                    class="tf-icons bx bx-x user-search-clear"
                    @click="form.crud.form.usuarioId = null"
                    title="Limpar"
                  ></i>
                </div>
                <teleport to="body">
                  <div
                    v-if="userSearchOpen"
                    class="user-search-dropdown"
                    :style="userDropdownStyle"
                  >
                    <div v-if="filteredUsers.length === 0" class="user-search-empty">
                      Nenhum usuário encontrado.
                    </div>
                    <div
                      v-for="u in filteredUsers"
                      :key="u.usuarioId"
                      class="user-search-item"
                      :class="{ 'is-selected': u.usuarioId === form.crud.form.usuarioId }"
                      @mousedown.prevent="selectUser(form, u)"
                    >
                      {{ u.name }}
                    </div>
                  </div>
                </teleport>
                <Error
                  v-if="form.crud.error"
                  :error="form.crud.error.firmware"
                ></Error>
              </div>
              <!-- <div class="mb-3 col-md-12 col-12">
                <label class="form-label">Token público *</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="form.crud.form.publicToken"
                />
                <Error
                  v-if="form.crud.error"
                  :error="form.crud.error.publicToken"
                ></Error>
              </div>
              <div class="mb-3 col-md-12 col-12">
                <label class="form-label">Token privado</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="form.crud.form.privateToken"
                />
                <Error
                  v-if="form.crud.error"
                  :error="form.crud.error.modelo"
                ></Error>
              </div> -->
              <hr />

              <div class="mb-3 col-12 col-md-6" v-if="form.crud.form.created">
                <label class="form-label">Criado</label>
                <input
                  type="datetime-local"
                  class="form-control"
                  readonly
                  :value="form.crud.form.created"
                />
              </div>
              <div class="mb-3 col-12 col-md-6" v-if="form.crud.form.updated">
                <label class="form-label">Atualizado</label>
                <input
                  type="datetime-local"
                  class="form-control"
                  readonly
                  :value="form.crud.form.updated"
                />
              </div>
            </div>
          </template>
          <template v-slot:filter="data">
            <div>
              <div class="mb-3">
                <label class="form-label">Nome</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="data.filters.nome"
                />
              </div>
              <div class="mb-3">
                <label class="form-label">Usuário</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="data.filters.usuarioNome"
                />
              </div>
            </div>
          </template>
        </Crud>
      </template>
    </Layout>

    <Alert ref="alert"></Alert>
  </div>
</template>
<script>
import Crud from "../../components/crud/Crud.vue";
import Datatable from "../../components/crud/Datatable.vue";
import Layout from "../../components/layout/Tema.vue";
import Error from "../../components/Error.vue";
import Alert from "../../components/Alert.vue";

export default {
  components: {
    Crud,
    Layout,
    Datatable,
    Error,
    Alert,
  },
  data() {
    return {
      showToken: null,
      numeros: null,
      ilimitado: false,
      users: [],
      loadingUsers: false,
      userSearch: "",
      userSearchOpen: false,
      userDropdownStyle: {},
      where: {
        nome: {
          operator: "LIKE",
          replace: "%{value}%",
        },
        usuarioNome: {
          operator: "LIKE",
          replace: "%{value}%",
        },
      },

      fields: [
        { name: "ID", value: "id", style: { width: "70px" } },
        { name: "Nome", value: "nome", style: { minWidth: "200px" } },
        { name: "Usuário", value: "usuarioNome", style: { minWidth: "200px" } },

        { name: "Chave pública", value: "publicToken", type: "slot" },
        {
          name: "Chave privada",
          value: "privateToken",
          type: "slot",
        },
        {
          name: "Expiração",
          value: "expire",
          style: { width: "100px" },
          format: (v, d) => {
            if (v != null && v != "9999-12-31T23:59:59.9999999") {
              return new Date(v).toLocaleString('pt-BR');
            } else {
              return "Nunca";
            }
          },
        },
        {
          name: "Criado",
          value: "created",
          style: { width: "180px" },
          format: (v, d) => {
            if (v != null) {
              return new Date(v).toLocaleString('pt-BR');
            } else {
              return "-";
            }
          },
        },
        {
          name: "Ação",
          type: "action",
          orderby: false,
          value: "status",
          edit: true,
          delete: true,
          style: { width: "100px", textAlign: "center" },
        },
      ],
      fieldsMobile: [
        { name: "ID / Nome", value: ["id", "nome"] },
        { name: "Usuário", value: "usuarioNome" },
        { name: "Chave pública", value: "publicToken", type: "slot" },
        { name: "Chave privada", value: "privateToken", type: "slot" },
        { name: "Expiração", value: "expire", format: (v, d) => {
            if (v != null && v != "9999-12-31T23:59:59.9999999") {
              return new Date(v).toLocaleString('pt-BR');
            } else {
              return "Nunca";
            }
          }
        },
        { name: "Ação", type: "action", orderby: false, value: "status", edit: true, delete: true },
      ],
    };
  },
  computed: {
    filteredUsers() {
      const q = (this.userSearch || "").trim().toLowerCase();
      if (!q) return this.users;
      return this.users.filter((u) =>
        (u.name || "").toLowerCase().includes(q)
      );
    },
  },
  mounted() {
    this.loadUsers();
    document.addEventListener("mousedown", this.onDocClick);
    window.addEventListener("resize", this.updateUserDropdownPos);
    window.addEventListener("scroll", this.updateUserDropdownPos, true);
  },
  beforeUnmount() {
    document.removeEventListener("mousedown", this.onDocClick);
    window.removeEventListener("resize", this.updateUserDropdownPos);
    window.removeEventListener("scroll", this.updateUserDropdownPos, true);
  },
  methods: {
    loadUsers() {
      this.loadingUsers = true;
      this.urlPost("/ApiToken/User")
        .then((res) => {
          this.users = res.data.itens || [];
        })
        .finally(() => {
          this.loadingUsers = false;
        });
    },
    userInputDisplay(usuarioId) {
      if (usuarioId == null) return "";
      const u = this.users.find((x) => x.usuarioId === usuarioId);
      return u ? u.name : "";
    },
    openUserSearch(currentId) {
      this.userSearch = "";
      this.userSearchOpen = true;
      this.$nextTick(this.updateUserDropdownPos);
    },
    selectUser(form, user) {
      form.crud.form.usuarioId = user.usuarioId;
      this.userSearchOpen = false;
      this.userSearch = "";
    },
    updateUserDropdownPos() {
      if (!this.userSearchOpen) return;
      const wrap = this.$refs.userSelectWrap;
      if (!wrap) return;
      const r = wrap.getBoundingClientRect();
      const spaceBelow = window.innerHeight - r.bottom;
      const openAbove = spaceBelow < 240 && r.top > spaceBelow;
      this.userDropdownStyle = {
        position: "fixed",
        left: r.left + "px",
        width: r.width + "px",
        ...(openAbove
          ? { bottom: window.innerHeight - r.top + 4 + "px" }
          : { top: r.bottom + 4 + "px" }),
      };
    },
    onDocClick(e) {
      if (!this.userSearchOpen) return;
      const wrap = this.$refs.userSelectWrap;
      if (wrap && wrap.contains(e.target)) return;
      if (e.target.closest && e.target.closest(".user-search-dropdown")) return;
      this.userSearchOpen = false;
    },
    noExpire(form) {
      form.crud.form.expire = "9999-12-31T23:59:59.9999999";
      this.ilimitado = !this.ilimitado
    },
    forceRerender() {
      this.component = false;
      this.$nextTick(() => {
        this.component = true;
      });
    },
    onformcreate(form) {
      form.usuarioId = null;
    },
    isMobile() {
      return window.innerWidth < 768;
    },
  },
};
</script>

<style>
.user-search-select {
  position: relative;
}
.user-search-clear {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #a1acb8;
  font-size: 1.1rem;
}
.user-search-clear:hover {
  color: #566a7f;
}
.user-search-dropdown {
  z-index: 1080;
  background: #fff;
  border: 1px solid #d9dee3;
  border-radius: 6px;
  box-shadow: 0 4px 16px rgba(67, 89, 113, 0.18);
  max-height: 240px;
  overflow-y: auto;
  padding: 4px 0;
}
.user-search-item {
  padding: 8px 12px;
  cursor: pointer;
  font-size: 0.9rem;
  color: #566a7f;
}
.user-search-item:hover,
.user-search-item.is-selected {
  background-color: #f5f5f9;
}
.user-search-empty {
  padding: 8px 12px;
  font-size: 0.85rem;
  color: #a1acb8;
}
</style>
